import React from 'react';
import { useNavigate } from 'react-router-dom'; // Ensure useNavigate is imported
import { GrInProgress } from "react-icons/gr";
import './PopupComponent.scss';

const PopupComponent = ({ onClose }) => {
  const navigate = useNavigate(); // Use the useNavigate hook for navigation

  // Function to handle navigation to the 'Middle' page
  const handleNavigate = (e) => {
    e.stopPropagation(); // Stop event propagation
    navigate('/Middle'); // Navigate to the specified page
  };

  // Handle click outside the popup content to also navigate
  const handleOutsideClick = (e) => {
    if (e.target.id === 'popup-background') {
      e.stopPropagation(); // Stop event propagation
      handleNavigate(e); // Call handleNavigate when the background is clicked
    }
  };

  return (
    <div id="popup-background" className="popup-background" onClick={handleOutsideClick}>
      <div className="popup-container">
        <div className="popup-header">upload files</div>
        <div className="progress-container">
          <div className="progress-circle"><GrInProgress /></div>
        </div>
        <button className="popup-button" onClick={handleNavigate}>cancel upload</button>
      </div>
    </div>
  );
};

export default PopupComponent;
